import React, { useMemo, useState } from "react";
import { Container, Row, Col, Card, Button, Badge, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

/* IMAGES (keep these inside src/.. so bundler copies them to build/static) */
import h1 from "../img/h1.jpg";
import h2 from "../img/h2.jpg";
import h3 from "../img/teagarden.jpg";
import h4 from "../img/jwl1.jpg";
import h5 from "../img/h4.jpg";
import h6 from "../img/h5.jpg";
import h7 from "../img/h6.jpg";
import h8 from "../img/h7.jpg";
import h9 from "../img/h9.jpg";
import h10 from "../img/h10.jpg";
import h11 from "../img/h11.jpg";
import h12 from "../img/h12.jpg";
import h13 from "../img/retail.jpg";

const Product = () => {
  const [query, setQuery] = useState("");
  const [tag, setTag] = useState("All");

  const products = useMemo(
    () => [
      {
        id: "salesync",
        title: "SaleSync",
        subtitle: "Retail POS & Inventory Software",
        image: h13,
        to: "/Retails",
        tag: "Retail",
        desc:
          "Touch-enabled retail POS and inventory system designed for fast billing, stock control, GST compliance and real-time business insights.",
      },
      {
        id: "hotelsof",
        title: "HotelSof",
        subtitle: "Hotel & Resort Management System",
        image: h1,
        to: "/Hotelsof",
        tag: "Hospitality",
        desc:
          "Complete PMS with front office, POS, housekeeping, accounting, inventory and GST-ready reporting for hotels and resorts.",
      },
      {
        id: "jewsof",
        title: "JewSof",
        subtitle: "Jewellery ERP Software",
        image: h4,
        to: "/jewsof",
        tag: "Jewellery",
        desc:
          "GST-enabled jewellery business software with barcode, stock, manufacturing and advanced sales analysis tools.",
      },
      {
        id: "teasof",
        title: "TeaSof",
        subtitle: "Tea Garden ERP",
        image: h3,
        to: "/teasof",
        tag: "Tea Garden",
        desc:
          "Specialized ERP for tea estates covering wages, garden activity, inventory, factory management and attendance automation.",
      },
      {
        id: "teasale",
        title: "TeaSale",
        subtitle: "Tea Trading & Blending Software",
        image: h6,
        to: "/teasale",
        tag: "Tea Trade",
        desc:
          "Software for tea manufacturers and traders with blending, auction sales, billing and stock analysis.",
      },
      {
        id: "wardmaster",
        title: "WardMaster",
        subtitle: "Hospital & Nursing Home Software",
        image: h2,
        to: "/Hospital",
        tag: "Healthcare",
        desc:
          "Modular hospital management system covering OPD, IPD, pharmacy, diagnostics, payroll and accounting.",
      },
      {
        id: "pharmacist",
        title: "Pharmacist",
        subtitle: "Pharmacy Distribution Software",
        image: h5,
        to: "/pharma",
        tag: "Pharma",
        desc:
          "Accounting and inventory software for medicine distributors with batch tracking, expiry alerts and profit analysis.",
      },
      {
        id: "restaursof",
        title: "RestaurSof",
        subtitle: "Restaurant POS & Accounting",
        image: h7,
        to: "/restaurant",
        tag: "Restaurant",
        desc:
          "GST-enabled restaurant management software with KOT/BOT, billing, recipe costing and reports.",
      },
      {
        id: "bakerypro",
        title: "BakeryPro",
        subtitle: "Bakery Management Software",
        image: h8,
        to: "/bakery",
        tag: "Bakery",
        desc:
          "End-to-end bakery ERP covering orders, production, delivery, billing and inventory.",
      },
      {
        id: "pathosof",
        title: "PathoSof",
        subtitle: "Pathology & Diagnostic Software",
        image: h9,
        to: "/pathology",
        tag: "Diagnostics",
        desc:
          "Lab management system for billing, test reports, patient records and automated workflows.",
      },
      {
        id: "transportpro",
        title: "TransportPro",
        subtitle: "Transport & Logistics Software",
        image: h10,
        to: "/transport",
        tag: "Transport",
        desc:
          "Web-based transport solution for fleet, billing, consignments and operational tracking.",
      },
      {
        id: "payhr",
        title: "PayHR",
        subtitle: "Payroll & HR Software",
        image: h11,
        to: "/paysof",
        tag: "HR / Payroll",
        desc:
          "Payroll and HR software integrated with biometric attendance and statutory reports.",
      },
      {
        id: "newspro",
        title: "NewsPro",
        subtitle: "Newspaper Accounting Software",
        image: h12,
        to: "/newssof",
        tag: "Media",
        desc:
          "Complete accounting system for newspaper circulation, advertising and ABC analysis.",
      },
    ],
    []
  );

  const tags = useMemo(() => ["All", ...new Set(products.map((p) => p.tag))], [products]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return products.filter((p) => {
      const matchesTag = tag === "All" || p.tag === tag;
      const matchesQuery =
        !q ||
        p.title.toLowerCase().includes(q) ||
        p.subtitle.toLowerCase().includes(q) ||
        p.desc.toLowerCase().includes(q);

      return matchesTag && matchesQuery;
    });
  }, [products, query, tag]);

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Business Software Products | EBS Software Solution India</title>
        <meta
          name="description"
          content="Explore GST-enabled ERP, POS, Retail, Hotel, Hospital, Tea Garden, Jewellery and Industry-specific software solutions by EBS Software Solution."
        />
      </Helmet>

      {/* HERO */}
      <div
        style={{
          background: "linear-gradient(120deg, #0b1220 0%, #111827 60%, #ff6a00 140%)",
          padding: "70px 0",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Container>
          <Badge bg="light" style={{ fontWeight: 900, marginBottom: 12 }}>
            OUR PRODUCTS
          </Badge>
          <h1 style={{ color: "#fff", fontWeight: 900 }}>Industry-Focused Business Software</h1>
          <p
            style={{
              color: "rgba(255,255,255,0.85)",
              maxWidth: 900,
              lineHeight: 1.8,
              marginTop: 12,
            }}
          >
            Discover enterprise-ready, GST-compliant software solutions designed to automate operations,
            improve accuracy and scale your business.
          </p>
        </Container>
      </div>

      {/* FILTER */}
      <Container className="py-4">
        <Row className="g-3">
          <Col md={6}>
            <Form.Control
              placeholder="Search software..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Select value={tag} onChange={(e) => setTag(e.target.value)}>
              {tags.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={2} className="d-grid">
            <Button
              variant="dark"
              onClick={() => {
                setQuery("");
                setTag("All");
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Container>

      {/* PRODUCT GRID */}
      <Container className="pb-5">
        <Row className="g-4">
          {filtered.map((p) => (
            <Col lg={4} md={6} key={p.id}>
              <Card
                className="h-100"
                style={{
                  borderRadius: 16,
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 14px 34px rgba(0,0,0,0.08)",
                }}
              >
                <Card.Img
                  src={p.image}
                  alt={`${p.title} - ${p.subtitle}`}
                  loading="lazy"
                  style={{ height: 220, objectFit: "cover" }}
                />
                <Card.Body>
                  <Badge bg="secondary" className="mb-2">
                    {p.tag}
                  </Badge>
                  <h5 style={{ fontWeight: 900 }}>{p.title}</h5>
                  <p style={{ color: "#475569", fontSize: 14 }}>{p.subtitle}</p>
                  <p style={{ fontSize: 14, lineHeight: 1.7 }}>{p.desc}</p>

                  <div className="d-grid">
                    <Button as={Link} to={p.to} variant="dark" style={{ fontWeight: 800 }}>
                      View Product
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
          {filtered.length === 0 && (
            <Col>
              <div style={{ padding: 20, border: "1px dashed #cbd5e1", borderRadius: 12 }}>
                No products found. Try a different search or reset filters.
              </div>
            </Col>
          )}
        </Row>
      </Container>

      {/* CTA */}
      <Container className="pb-5">
        <div
          style={{
            borderRadius: 18,
            padding: 30,
            background: "linear-gradient(120deg, #111827 0%, #0b1220 100%)",
            color: "#fff",
          }}
        >
          <Row className="align-items-center">
            <Col lg={8}>
              <h4 style={{ fontWeight: 900 }}>Need Customization or a Demo?</h4>
              <p style={{ opacity: 0.85 }}>
                Talk to our experts and get the right solution for your business.
              </p>
            </Col>
            <Col lg={4} className="d-grid">
              <Button as={Link} to="/EmailContactForm" variant="warning" style={{ fontWeight: 900 }}>
                Contact Us
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Product;